/* eslint-disable global-require */
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Col, Row, Image, Form, Container, Button } from "react-bootstrap";
import { SpinnerDotted } from "spinners-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faArrowLeft } from "@fortawesome/fontawesome-free-solid";
import { getCookies } from "../../hooks/useCookies";
import { TableContext } from "../../contexts/tableContext";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import styles from "./viewPopup.module.scss";
import { DateFormatter } from "../../utilityFunctions/utilsFunctions";
import envValues from "../../enviornment";
import { Entry } from "../../redux/entrySlice";
import { useDispatch } from "react-redux";

const ViewTicketPopup = React.memo(({ ticketId, handleClose }) => {
  const { dashboardStyle } = useContext(TableContext);
  const { formthemeStyle, bodyheader, viewformStyle } =
    useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);
  const dispatch = useDispatch();
  const params = useParams();
  // let issueId;
  const token = `Bearer ${getCookies("Token")}`;
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const dateFormat = getCookies("dateFormat");
  const [canDelete, setCanDelete] = useState(true);
  const [refundSubmitting, setRefundSubmitting] = useState(false);
  const [cancelSubmitting, setCancelSubmitting] = useState(false);

  const [commentText, setCommentText] = useState("");

  let statusCode;
  const getUserDetails = async () => {
    setLoading(true);
    axios
      .get(`${envValues.REACT_APP_API_ENDPOINT}/tickets/${ticketId}`, {
        method: "GET",
        headers: { Authorization: token },
      })
      .then((resp) => {
        statusCode = resp.status;
        return resp.data;
      })
      .then((res) => {
        if (statusCode === 200) {
          console.log("res.data.user", res.data.ticket);
          setDetails(res.data.ticket);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    getUserDetails();
  }, []);

  const onReplyComment = async () => {
    if (!commentText.trim()) return;

    const apiData = {
      comment: commentText,
    };

    const data = {
      actionUrl: `tickets/add-comment/${ticketId}`,
      actionMethod: "patch",
      apiData,
    };

    try {
      // Optional: You can use setSubmitting(true) here if you want to show a loader
      const resp = await dispatch(Entry(data));

      if (resp?.payload?.code === 200) {
        toast.success("Comment added successfully");
        // handleClose(); // Closes the modal
        getUserDetails();
      } else {
        toast.error("Error adding comment");
      }
    } catch (error) {
      console.error("Error in submitting comment:", error);
      toast.error("Something went wrong");
    } finally {
      // Optional: setSubmitting(false);
      setCommentText(""); // Clear the textarea
    }
  };

  const onInitiateRefund = async () => {
    setRefundSubmitting(true);
    const data = {
      actionUrl: `tickets/initiate-refund/${ticketId}`,
      actionMethod: "patch",
    };

    try {
      // Optional: You can use setSubmitting(true) here if you want to show a loader
      const resp = await dispatch(Entry(data));

      if (resp?.payload?.code === 200) {
        toast.success("Refund completed successfully");
        // handleClose(); // Closes the modal
        getUserDetails();
      } else {
        toast.error("Error initiating refund");
      }
    } catch (error) {
      console.error("Error in submitting comment:", error);
      toast.error("Something went wrong");
    } finally {
      setRefundSubmitting(false);
    }
  };

  const onCancelRefund = async () => {
    setCancelSubmitting(true);
    const data = {
      actionUrl: `tickets/cancel-refund/${ticketId}`,
      actionMethod: "patch",
    };

    try {
      // Optional: You can use setSubmitting(true) here if you want to show a loader
      const resp = await dispatch(Entry(data));

      if (resp?.payload?.code === 200) {
        toast.success("Refund canceled successfully");
        // handleClose(); // Closes the modal
        getUserDetails();
      } else {
        toast.error("Error canceling refund");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setCancelSubmitting(false);
    }
  };

  return (
    <div className={styles.popupbox}>
      <div className={styles[formthemeStyle]} id={styles.box}>
        <span
          className={styles.closeicon}
          role="button"
          tabIndex={0}
          onClick={handleClose}
          onKeyDown={handleClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </span>

        {loading ? (
          <SpinnerDotted style={{ color: "#39979d", marginLeft: "50%" }} />
        ) : (
          <Container fluid>
            <Row>
              <h5 className={styles[bodyheader]} id={styles.addheading}>
                Ticket Details
              </h5>
            </Row>

            <Row className="mt-3">
              <Col lg={12}>
                <div className={styles.detaildiv}>
                  <Row>
                    <Col lg={3} md={6} sm={12}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Name</span>
                        <p className={styles.empname}>{details?.user?.name}</p>
                      </div>
                    </Col>
                    <Col lg={3} md={6} sm={12}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Email</span>
                        <p className={styles.empname}>
                          {details?.user?.email ?? "NA"}
                        </p>
                      </div>
                    </Col>
                    {/* </Row>
                  <Row> */}
                    <Col lg={3} md={6} sm={12}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Order Id</span>
                        <p className={styles.empname}>
                          {details?.order_id ?? "NA"}
                        </p>
                      </div>
                    </Col>
                    <Col lg={3} md={6} sm={12}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Description</span>
                        <p className={styles.empname}>
                          {details?.description ?? "NA"}
                        </p>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={3} md={6} sm={12}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Posted On</span>
                        <p className={styles.empname}>
                          {details?.createdAt
                            ? DateFormatter(
                                details?.createdAt,
                                dateFormat || "MonthDayYear"
                              )
                            : "NA"}
                        </p>
                      </div>
                    </Col>
                    <Col lg={3} md={6} sm={12}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>Refund Amount</span>
                        <p className={styles.empname}>
                          ${details?.refundAmount ?? 0}
                        </p>
                      </div>
                    </Col>
                    <Col lg={3} md={6} sm={12}>
                      <div className={styles[viewformStyle]} id={styles.empdiv}>
                        <span className={styles.title}>status</span>
                        <p className={styles.empname}>{details?.status}</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>

            {/* Comments Section */}
            <Row className="mt-4">
              <Col lg={12}>
                <h6 className={styles.commentTitle}>Comments</h6>
                <div className={styles.commentsBox}>
                  {details?.comments?.length > 0 ? (
                    details.comments.map((comment, index) => (
                      <div key={index} className={styles.commentItem}>
                        <div className={styles.commentHeader}>
                          <strong className={styles.commentAuthor}>
                            {comment?.admin?.name ||
                              comment?.user?.name ||
                              "Unknown"}
                            :
                          </strong>
                          <span className={styles.commentMessage}>
                            {comment.message}
                          </span>
                        </div>
                        <div className={styles.commentedTime}>
                          {comment?.commentedAt
                            ? DateFormatter(
                                comment?.commentedAt,
                                dateFormat || "MonthDayYear"
                              )
                            : "NA"}
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No comments yet.</p>
                  )}
                </div>

                {/* Reply Form */}
                <Form className="mt-3">
                  <Form.Group controlId="comment">
                    <Form.Label>Reply as Admin</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder="Type your message here..."
                      value={commentText}
                      onChange={(e) => setCommentText(e.target.value)}
                    />
                  </Form.Group>
                  <Button
                    variant="primary"
                    className="mt-2"
                    disabled={!commentText.trim()}
                    onClick={() => {
                      onReplyComment(commentText);
                      setCommentText("");
                    }}
                  >
                    Submit Comment
                  </Button>
                </Form>
              </Col>
            </Row>
            {/* Action Buttons */}
            {details?.status === "Open" && (
              <Row className="mt-4">
                <Col className="d-flex justify-content-end gap-2">
                  <Button
                    variant="success"
                    onClick={onInitiateRefund}
                    disabled={refundSubmitting}
                  >
                    Initiate Refund
                  </Button>
                  <Button
                    variant="danger"
                    onClick={onCancelRefund}
                    disabled={cancelSubmitting}
                  >
                    Cancel Refund
                  </Button>
                </Col>
              </Row>
            )}
          </Container>
        )}
      </div>
    </div>
  );
});

export default ViewTicketPopup;
